import { createContext } from "react";

export const SuperadminBillsContext = createContext();
